module.exports = __webpack_public_path__ + "assets/52ad34b9cca62c3643676baabdd23c0c.png";